import { userConstants } from '../constants';
import { UserResponse } from '../py-generated/datalouder/third_party_login/types';

// migration localstorage.user
const migrateLocalstorageUser = () => {
  const userRaw = localStorage.getItem('user');
  if (userRaw) {
    try {
      const user = JSON.parse(userRaw);
      if (user.email) {
        // eslint-disable-next-line no-console
        console.log('Migrating to new user');
        // old version
        const newUser: UserResponse & { authToken: string } = {
          id: user.id,
          login: user.email,
          alias: user.alias,
          hasMembership: user.hasMembership,
          registeredAt: 0, // wait for refetch
          isAdmin: false, // wait for refetch
          expireAt: user.hasMembership ? 0 : null,
          loginVerified: true, // wait for refetch
          authToken: user.tokenKey,
        };
        localStorage.setItem('user', JSON.stringify(newUser));
        // eslint-disable-next-line no-console
        console.log('Completed to new user');
      }
    } catch {
      // eslint-disable-next-line no-console
      console.log('Resetting localstorage.user');
      localStorage.removeItem('user');
    }
  }
};
migrateLocalstorageUser();

const currentUser = JSON.parse(localStorage.getItem('user'));
const initialState = currentUser
  ? { user: currentUser, loading: false, registered: undefined }
  : { user: undefined, loading: false, registered: undefined };

interface UserState {
  loading?: boolean;
  user?: UserResponse;
  error?: Error;
  registered?: boolean;
}

export default (state: UserState = initialState, action): UserState => {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
    case userConstants.REGISTER_REQUEST: {
      return {
        loading: true,
      };
    }
    case userConstants.REGISTER_SUCCESS: {
      return {
        registered: true,
        user: action.user,
      };
    }
    case userConstants.REGISTER_FAILURE:
    case userConstants.LOGIN_FAILURE: {
      return {
        error: action.error,
      };
    }
    case userConstants.LOGIN_SUCCESS:
    case userConstants.UPDATE_PROFILE_SUCCESS:
    case userConstants.REFRESH_SUCCESS: {
      return {
        user: action.user,
      };
    }

    case userConstants.UPDATE_PROFILE_REQUEST: {
      return {
        loading: true,
        user: action.user,
      };
    }
    case userConstants.UPDATE_PROFILE_FAILURE: {
      return {
        user: action.user,
        error: action.error,
      };
    }
    case userConstants.REFRESH_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case userConstants.REFRESH_FAILURE: {
      return {
        ...state,
        error: action.error,
      };
    }

    case userConstants.LOGOUT: {
      return {
        user: undefined,
      };
    }
    default: {
      return state;
    }
  }
};
